import {
  FETCH_PACKAGE_DELIVERY_RANGES_PENDING,
  FETCH_PACKAGE_DELIVERY_RANGES_REJECTED,
  FETCH_PACKAGE_DELIVERY_RANGES_FULFILLED,
  CLEAR_PACKAGE_DELIVERY_RANGES
} from "../constants/packageDeliveryRanges";

const initialState = {
  pending: true,
  deliveryRanges: [],
  error: {}
};

export const packageDeliveryRanges = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PACKAGE_DELIVERY_RANGES_PENDING:
      return { ...state, pending: true, error: {} };

    case FETCH_PACKAGE_DELIVERY_RANGES_REJECTED:
      return {
        ...state,
        pending: false,
        error: action.error
      };

    case FETCH_PACKAGE_DELIVERY_RANGES_FULFILLED:
      return {
        ...state,
        deliveryRanges: action.data.results,
        pending: false,
        error: {}
      };

      case CLEAR_PACKAGE_DELIVERY_RANGES:
        return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/packageDeliveryRanges.js